import { render } from "./edit_page.vue?vue&type=template&id=1812fded&lang=pug"
import script from "./edit_page.vue?vue&type=script&lang=js"
export * from "./edit_page.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hash_pick/releases/20261030073454/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__